import { Component } from '@angular/core';
import { Tag } from 'primeng/tag';
import { SampleState } from '../../../../../../types/sample/SampleState';
import { EnumLabelPipe } from '../../../../pipes/enum-label.pipe';
import { SampleStateSeverityPipe } from '../../../../pipes/sample-state-severity.pipe';

@Component({
    selector: 'app-sample-process',
    imports: [
        Tag,
        SampleStateSeverityPipe,
        EnumLabelPipe
    ],
    templateUrl: './sample-process.component.html',
    styleUrl: './sample-process.component.scss'
})
export class SampleProcessComponent {

    protected readonly SampleState = SampleState;
}
